var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bj-upload-20210723", class: _vm.classID },
    [
      _c(
        "el-upload",
        {
          ref: "upload",
          staticClass: "upload-demo",
          class: { "hide-upload": _vm.hideUpload },
          attrs: {
            action: "",
            "on-preview": _vm.handlePreview,
            "on-remove": _vm.handleRemove,
            "on-success": _vm.handleSuccess,
            "on-error": _vm.handleError,
            "on-progress": _vm.handlePropress,
            "on-exceed": _vm.handleExceed,
            "file-list": _vm.fileList,
            "auto-upload": _vm.autoUpload,
            "on-change": _vm.handleChange,
            "before-upload": _vm.bjBeforeUpload,
            "http-request": _vm.httpRequest,
            multiple: _vm.multiple,
            "list-type": _vm.listType,
            "show-file-list": _vm.showFileList,
            accept: _vm.accept,
            disabled: _vm.disabled,
          },
        },
        [
          _vm._t("default"),
          !_vm.$slots.default
            ? _c(
                "el-button",
                {
                  attrs: { slot: "trigger", size: "small", type: "primary" },
                  slot: "trigger",
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("BusinessImportHistory.page.SelectFile"))
                  ),
                ]
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "el-upload__tip",
              attrs: { slot: "tip" },
              slot: "tip",
            },
            [_vm._t("tip")],
            2
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }